/**
 * KWC floating collection cards.
 *
 * Progressive enhancement only: the cards, links and CSS float animation all
 * work without this file. This adds the scroll entrance, the pointer parallax
 * and the carousel dots.
 *
 * The float lives on the <img> in CSS; the parallax is written to the wrapper
 * (.kwc-fc-card__product). Keeping them on separate elements means the two
 * transforms never overwrite one another.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FINE = window.matchMedia('(pointer: fine)');

  function initTilt(card) {
    var panel = card.querySelector('[data-kwc-fc-panel]');
    var product = card.querySelector('[data-kwc-fc-product]');
    var content = card.querySelector('[data-kwc-fc-content]');
    if (!panel) return;

    var frame = null;
    var baseTilt = 11;

    function apply(x, y) {
      panel.style.transform =
        'perspective(1400px) rotateY(' + (baseTilt + x * 5) + 'deg) rotateX(' + y * -4 + 'deg)';
      if (product) product.style.translate = x * 14 + 'px ' + y * 10 + 'px';
      if (content) content.style.translate = x * 4 + 'px ' + y * 3 + 'px';
    }

    card.addEventListener('pointermove', function (event) {
      if (!FINE.matches || REDUCED.matches) return;
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        apply(x * 2, y * 2);
      });
    });

    card.addEventListener('pointerleave', function () {
      if (frame) {
        cancelAnimationFrame(frame);
        frame = null;
      }
      // Clearing the inline values hands control back to the stylesheet, whose
      // own transition eases everything home.
      panel.style.transform = '';
      if (product) product.style.translate = '';
      if (content) content.style.translate = '';
    });
  }

  function initEntrance(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kwc-fc-card]'));

    if (REDUCED.matches || !('IntersectionObserver' in window)) {
      cards.forEach(function (card) { card.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var card = entry.target;
          var order = cards.indexOf(card);
          setTimeout(function () { card.classList.add('is-in'); }, Math.max(order, 0) * 120);
          observer.unobserve(card);
        });
      },
      { threshold: 0.15 }
    );

    cards.forEach(function (card) { observer.observe(card); });
  }

  function initDots(root) {
    var row = root.querySelector('[data-kwc-fc-row]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kwc-fc-dot]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kwc-fc-card]'));
    if (!row || dots.length === 0) return;

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var target = cards[parseInt(dot.getAttribute('data-index'), 10) || 0];
        if (!target) return;
        row.scrollTo({
          left: target.offsetLeft - row.offsetLeft,
          behavior: REDUCED.matches ? 'auto' : 'smooth'
        });
      });
    });

    // Mark the card nearest the row's centre as active.
    var ticking = false;
    row.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var centre = row.scrollLeft + row.clientWidth / 2;
          var best = 0;
          var bestDistance = Infinity;
          cards.forEach(function (card, i) {
            var cardCentre = card.offsetLeft - row.offsetLeft + card.offsetWidth / 2;
            var distance = Math.abs(cardCentre - centre);
            if (distance < bestDistance) {
              bestDistance = distance;
              best = i;
            }
          });
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === best);
          });
        });
      },
      { passive: true }
    );
  }

  function initSection(root) {
    initEntrance(root);
    initDots(root);
    root.querySelectorAll('[data-kwc-fc-card]').forEach(initTilt);
  }

  function init() {
    document.querySelectorAll('[data-kwc-fc]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-kwc-fc]');
    if (root) initSection(root);
  });
})();
